export const redirect = (redirect = {}) => {
  try {
    if (!redirect.pathname || !window.location.pathname || redirect.pathname === window.location.pathname) {
      throw new Error(`!!! ERROR (redirect) Redirect attempted, but criteria not met to proceed.  Requested redirect path: ${redirect && redirect.pathname}, current URL: ${window.location.href}`)
    }

    console.log(`DEBUG (redirect): Redirecting to URL: ${redirect.pathname}`)
    window.location.href = redirect.pathname
  } catch (error) {
    console.log(error)
    console.log(redirect)
    MK.captureException && MK.captureException(error)
  }
}